import NormalAPI from "../../api";
import urls from "../../api/urls";
import { APIs } from "../../utils/worker";

const parsePincodeCoverageResponse = (response, defaultMessage) => {
  if (response?.response?.status === 200) {
    return {
      data: response?.response?.data?.data || [],
      total: response?.response?.data?.total || 0,
    };
  }

  throw new Error(response?.response?.data?.message || defaultMessage);
};

// Fetch all pincodes serviceability data
export const getAllPincodesServiceability = async () => {
  try {
    const response = await NormalAPI.Api(
      `${urls.GET_ALL_PINCODES_SERVICEABILITY}?is_active=true`
    ).getCustomHeader();

    return parsePincodeCoverageResponse(response, "Failed to fetch serviceable pincodes");
  } catch (error) {
    console.error("Error fetching all pincodes serviceability:", error);
    throw error;
  }
};

// Fetch full pincode dataset (used to derive non-serviceable pins on UI)
export const getAllNonServiceablePincodes = async () => {
  try {
    const response = await NormalAPI.Api(urls.GET_ALL_PINCODES_SERVICEABILITY).getCustomHeader();

    return parsePincodeCoverageResponse(response, "Failed to fetch non-serviceable pincodes");
  } catch (error) {
    console.error("Error fetching non-serviceable pincodes:", error);
    throw error;
  }
};

export const getHubMapListing = async ({ pageNo = 0, pageSize = 500 } = {}) => {
  try {
    const response = await NormalAPI.Api(
      `${APIs.baseURL}/premise-service/v1/premises/hub?pageNo=${pageNo}&pageSize=${pageSize}`
    ).getWithHeader();

    if (response?.status) {
      const responseData = response?.response?.data || {};
      const data =
        (Array.isArray(responseData?.hubList) && responseData?.hubList) ||
        (Array.isArray(responseData?.content) && responseData?.content) ||
        (Array.isArray(responseData?.items) && responseData?.items) ||
        (Array.isArray(responseData?.data) && responseData?.data) ||
        (Array.isArray(responseData) ? responseData : []);

      return {
        data,
        total:
          responseData?.hubCount ||
          responseData?.totalElements ||
          responseData?.totalCount ||
          responseData?.total ||
          (Array.isArray(data) ? data.length : 0),
      };
    }

    throw new Error(response?.response?.data?.message || "Failed to fetch hub map listing");
  } catch (error) {
    console.error("Error fetching hub map listing:", error);
    throw error;
  }
};
